import { ArrowRight } from "lucide-react";
import { SELECTED_WORK } from "../../data/content";

export const SelectedWork = () => (
  <section id="work" className="bg-[#F5F5F0] text-[#111111] px-6 lg:px-12 py-24 lg:py-32" data-testid="work-section">
    <div className="flex items-end justify-between mb-14">
      <p className="font-mono text-xs tracking-[0.35em] text-black/50 flex items-center gap-4">
        SELECTED WORK <span className="inline-block w-16 h-px bg-black/30" />
      </p>
      <span className="hidden md:inline-flex items-center gap-2 font-mono text-[10px] tracking-[0.3em] text-black/40">
        VIEW ALL CASE STUDIES <ArrowRight className="w-3.5 h-3.5" />
      </span>
    </div>
    <div className="grid md:grid-cols-3 gap-10">
      {SELECTED_WORK.map((w, i) => (
        <a
          key={w.title}
          href={w.href}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`work-card-${i}`}
          className="group block"
        >
          <div className="overflow-hidden aspect-[4/3]">
            <img
              src={w.img}
              alt={w.title}
              loading="lazy"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
            />
          </div>
          <p className="mt-6 font-mono text-[10px] tracking-[0.3em] text-black/50">{w.tag}</p>
          <h3 className="mt-2 font-display text-2xl lg:text-3xl leading-snug group-hover:underline underline-offset-4">
            {w.title}
          </h3>
          <p className="mt-3 text-sm leading-relaxed text-black/60">{w.desc}</p>
          <ArrowRight className="mt-5 w-4 h-4 text-black/40 group-hover:text-black group-hover:translate-x-1 transition-all duration-300" />
        </a>
      ))}
    </div>
  </section>
);
